/**
 * 重写库中的二级控制器
 */

import { MonixEraseControl } from "../subcontrols/MonixEraseControl";
import { MonixMoveControl } from "../subcontrols/MonixMoveControl";


export const PYTHA_SUB_CONTROL = {
    ERASE: { name: "ERASE", cmd: "EraseControl", clazz: MonixEraseControl },
    MOVE: { name: "MOVE", cmd: "MoveControl", clazz: MonixMoveControl },
}